import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class VelaroProvider {
    private loaded = false;

    constructor (
        @Inject(DOCUMENT) private document: Document,
    ) {}

    addScript (): void {
        if (this.shouldStartIntercom()) {
            this.initScript();
        }
    }

    private shouldStartIntercom (): boolean {
        return !this.loaded;
    }

    private initScript (): void {
        const script = this.document.createElement('script');
        script.nonce = 'cb56f32a23f';
        script.innerHTML = `
      (function(){ 
        var globals = document.createElement('script');
        globals.src = 'https://eastprodstorage.azureedge.net/velaroscripts/20608/globals.js';
        var inline = document.createElement('script');
        inline.src = 'https://eastprodcdn.azureedge.net/bundles/velaro.inline.js';
        var scriptNode = document.getElementsByTagName('script')[0];
        scriptNode.parentNode.insertBefore(globals, scriptNode); 
        globals.onload = function () { 
          Velaro.Globals.ActiveSite = 20608; 
          Velaro.Globals.ActiveGroup = 0; 
          Velaro.Globals.InlineEnabled = true;  
          Velaro.Globals.VisitorMonitoringEnabled = true; 
          Velaro.Globals.InlinePosition = 0; 
          scriptNode.parentNode.insertBefore(inline, scriptNode) 
        }
      })();
    `;
        this.loaded = true;
        this.document.body.appendChild(script);
    }
}
